import axios from 'axios';
import envs from '../common/env'
export default {
  fetchConpanyList({commit, state}, ages) {  //获取城市列表
   return  new Promise((resolve, reject) => {
      axios.post(envs.CommercialUrl+'/rescue-master/bussiness/api/admin/company/findAllCompany').then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  fetchCityList({commit, state}, args) {//获取城市列表
    // axios.post('/rm-user-manage/api/admin/city/listCityByOpen').then(res => {
    //   let data = res.data;
    //   if (data.code === 0) {
    //     //console.log(data);
    //     state.cityList = JSON.parse(JSON.stringify(data.data));
    //     state.contentCityList = JSON.parse(JSON.stringify(data.data));
    //     state.contentCityList.unshift({
    //       id: null,
    //       name: '全部',
    //       letterName: 'all'
    //     })
    //   }
    // });
  },
  fetchProjectList({commit, state}, args) {
    // axios.post('/rm-user-manage/api/admin/project/list').then(res => {
    //   //console.log(res)
    //   let data = res.data;
    //   if (data.code === 0) {
    //     state.projectList = data.data;
    //     // state.cityList.unshift({name: '全部', id: null})
    //   }
    // });
  },
  fetchAreaList({commit, state}, cityId) {//根据城市id获取分区
    return axios.get(`/rm-user-manage/api/admin/zone/listZone?cityId=${cityId}`);
  },
  fetchOnlineTimelyRainerList({commit, state}, currentOrderId) {//获取及时雨人员列表
    return new Promise((resolve, reject) => {
      axios.get(`/rescue-master/api/admin/user/getOnlineTimelyRainerList?orderId=${currentOrderId}&state=0`).then(res => {
        let data = res.data;
        if (data.code === 0) {
          resolve(data.data)
        }
      }).catch(err => {
        reject(err);
      });

    });

  },
  getLngLat({commit, state}, obj) {//获取城市经纬度
    //加载行政区划插件
    let district = state.district;
    if (!district) {
      //实例化DistrictSearch
      var opts = {
        subdistrict: 0,   //获取边界不需要返回下级行政区
        // extensions: 'all',  //返回行政区边界坐标组等具体信息
        level: 'city'  //查询行政级别为 市
      };
      district = new obj.AMap.DistrictSearch(opts);
    }
    //行政区查询
    district.search(obj.cityName || state.userInfo.cityName, (status, res) => {
      if (res.info == 'OK') {

        let cityInfo = res.districtList.filter(val => {
          if (val.level == 'city' || val.level == 'province') {
            return val;
          }
        })
        // let center=cityInfo.center;
        // console.log(cityInfo)
        // console.log(cityInfo.center)
        commit('LNGLAT_INIT', {district: district, center: cityInfo[0].center})


      }
    });
  },
  fetchDistanceByLnglat({commit, state}, obj) {//根据经纬度获取距离
    return new Promise((resolve, reject) => {
      let url = `https://restapi.amap.com/v3/direction/driving?key=972b25502905f75c5dea39a27a11736d&origin=${obj.originLnglat}&destination=${obj.accidentLngLat}&strategy=2`;
      var ajax = XMLHttpRequest ? new XMLHttpRequest() : new window.ActiveXObject('Microsoft.XMLHTTP');
      ajax.open('get', url, true);
      ajax.send();
      ajax.onreadystatechange = function () {
        if (ajax.readyState == 4 && ajax.status == 200) {
          let data = JSON.parse(ajax.responseText);
          if (data.status == 1 && data.info == 'OK' && data.route && data.route.paths && data.route.paths[0]) {
            let distance = data.route.paths[0].distance;
            resolve(distance);
          }
        }
      }

    });
  },
  fetchAllCompany({commit, state}) {
    return new Promise((resolve, reject) => {
      axios.post(envs.CommercialUrl+'/rescue-master/bussiness/api/admin/company/findAllCompany').then(res => {
        resolve(res);
      }).catch(err => {
        reject(err);
      });

    })
  },
  menuStatus({commit, state},val){
    commit('MENU_STATUS', val);
  },
  showMaskLayer({commit, state}, res) {
    commit('SHOW_MASK_LAYER', {
      res
    });

  },
  hideMaskLayer({commit, state}, res) {
    commit('HIDE_MASK_LAYER', {
      res
    });
  },
  updateToken({commit, state}, res) {
    commit('UPDATE_TOKEN', {
      res
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/action.js